import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// material
import {
  Button,
  Card,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import { Box } from '@mui/system';
// react icons
import CloseIcon from '@mui/icons-material/Close';
import { FaRegUser } from 'react-icons/fa';

// components
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import ApiErrorMessage from '../Global/ApiErrorMessage';
import Footer from '../Global/Footer';
import globalService from '../services/globalServices';
import leadsService from '../services/leadsService';
import OppositeContentTimeline from './OppositeContentTimeline';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';

const { AddComment, InternalSalesManager } = leadsService;

const { MasterListType } = globalService;

export default function CommentsLeads() {
  const navigate = useNavigate();
  const [openComments, setOpenComments] = useState(false);
  const [selectRequest, setSelectRequest] = useState(' ');
  const [taskMenu, setTaskMenu] = useState([]);
  const [assignTo, setAssignTo] = useState(' ');
  const [comments, setcomments] = useState('');
  const [open, setOpen] = useState(false);
  const [validationMsg, setValidationMsg] = useState('');
  const [openApiError, setOpenApiError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [token, setToken] = useState('');
  const [companyId, setCompanyId] = useState();
  const [userId, setUserId] = useState('');
  const [leadDetailsData, setLeadDetailsData] = useState(null);
  const [assignToList, setAssignToList] = useState([]);
  const { LoginData } = useLoginSelector();

  const handleSubmitComments = async (e) => {
    if (selectRequest === ' ') {
      setOpen(true);
      setValidationMsg('Please select task');
      return;
    }
    if (assignTo === ' ') {
      setOpen(true);
      setValidationMsg('Please select assign to');
      return;
    }
    if (comments === '') {
      setOpen(true);
      setValidationMsg('Please add comments');
      return;
    }

    const credentials1 = {
      assignedBy: userId,
      assignedTo: assignTo,
      comments: comments,
      companyId: companyId,
      leadId: leadDetailsData !== null ? leadDetailsData.leadesItem[0].leadId : null,
      taskId: selectRequest
    };
    const AddCommentApiResponse = await AddComment(credentials1, token);
    if (AddCommentApiResponse.status === 'success') {
      setOpenComments(false);
      setSelectRequest(' ');
      setAssignTo(' ');
      setcomments('');
    } else {
      setOpenApiError(true);
      setErrorMessage('Something went wrong !');
    }
  };

  useEffect(async () => {
    let leadDetails = localStorage.getItem('leadDetails');
    leadDetails = JSON.parse(leadDetails);
    setLeadDetailsData(leadDetails);
    if (LoginData !== null) {
      const authToken = LoginData?.jwt;
      setToken(authToken);
      const authCompanyId = LoginData?.companyId;
      setCompanyId(authCompanyId);
      const authUserId = LoginData?.userId;
      setUserId(authUserId);
      const type = 'LEAD_COMMENT_TASK_TYPE';
      const AddressTypeApiResponse = await MasterListType(type, authToken);
      if (AddressTypeApiResponse.status === 'success') {
        setTaskMenu(AddressTypeApiResponse.data.masterTypes);
      } else {
        setTaskMenu([]);
      }

      const credentials2 = {
        companyId: authCompanyId
      };
      const InternalSalesManagerApiResponse = await InternalSalesManager(credentials2, authToken);
      if (InternalSalesManagerApiResponse.msg) {
        if (InternalSalesManagerApiResponse.msg === 'Forbidden') {
          navigate('/');
        }
      }
      if (InternalSalesManagerApiResponse.status === 'success') {
        const finalData = InternalSalesManagerApiResponse.data.salesPersons.filter(
          (item, index) => authUserId !== item.userId
        );
        setAssignToList(finalData);
      } else {
        setAssignToList([]);
      }
    }
  }, []);

  return (
    <Page title="Comments">
      <Box className="mainBg" pb={4}>
        <Container maxWidth={false}>
          <Box pt={3} pb={3}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              className="pageHeading"
            >
              <PageTitle info="Comments" />
              <Box>
                <BrudCrumbs />
              </Box>
            </Stack>

            {/* applicant details */}
            {/* applicant details */}
            <Card
              sx={{
                borderRadius: '20px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 4px 14px rgba(0,0,0,0.03)',
                p: { xs: 2.5, md: 3 },
                mb: 3
              }}
            >
              <Typography
                variant="h6"
                sx={{ fontSize: 16, fontWeight: 700, color: '#13519d', mb: 2 }}
              >
                Application Details
              </Typography>
              <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
                <Grid item xs={12} sm={6} md={4}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <FaRegUser size={20} style={{ color: '#13519d' }} />
                    <Box>
                      <Typography variant="body2" sx={{ color: '#637381', fontSize: 12 }}>
                        Application No
                      </Typography>
                      <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#212b36' }}>
                        123456789
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <FaRegUser size={20} style={{ color: '#13519d' }} />
                    <Box>
                      <Typography variant="body2" sx={{ color: '#637381', fontSize: 12 }}>
                        Submitted On
                      </Typography>
                      <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#212b36' }}>
                        01/06/2022
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <FaRegUser size={20} style={{ color: '#13519d' }} />
                    <Box>
                      <Typography variant="body2" sx={{ color: '#637381', fontSize: 12 }}>
                        Submitted by
                      </Typography>
                      <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#212b36' }}>
                        Ramesh
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <FaRegUser size={20} style={{ color: '#13519d' }} />
                    <Box>
                      <Typography variant="body2" sx={{ color: '#637381', fontSize: 12 }}>
                        Mode of Submission
                      </Typography>
                      <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#212b36' }}>
                        Online
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <FaRegUser size={20} style={{ color: '#13519d' }} />
                    <Box>
                      <Typography variant="body2" sx={{ color: '#637381', fontSize: 12 }}>
                        Customer Type
                      </Typography>
                      <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#212b36' }}>
                        Banking
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <FaRegUser size={20} style={{ color: '#13519d' }} />
                    <Box>
                      <Typography variant="body2" sx={{ color: '#637381', fontSize: 12 }}>
                        Product
                      </Typography>
                      <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#212b36' }}>
                        Home Loan
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <FaRegUser size={20} style={{ color: '#13519d' }} />
                    <Box>
                      <Typography variant="body2" sx={{ color: '#637381', fontSize: 12 }}>
                        Customer ID
                      </Typography>
                      <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#212b36' }}>
                        A1B1
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <FaRegUser size={20} style={{ color: '#13519d' }} />
                    <Box>
                      <Typography variant="body2" sx={{ color: '#637381', fontSize: 12 }}>
                        Last KYC Update
                      </Typography>
                      <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#212b36' }}>
                        06/06/2022
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <FaRegUser size={20} style={{ color: '#13519d' }} />
                    <Box>
                      <Typography variant="body2" sx={{ color: '#637381', fontSize: 12 }}>
                        Verified by
                      </Typography>
                      <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#212b36' }}>
                        ABC
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <FaRegUser size={20} style={{ color: '#13519d' }} />
                    <Box>
                      <Typography variant="body2" sx={{ color: '#637381', fontSize: 12 }}>
                        Verified on
                      </Typography>
                      <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#212b36' }}>
                        08/11/2022
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <FaRegUser size={20} style={{ color: '#13519d' }} />
                    <Box>
                      <Typography variant="body2" sx={{ color: '#637381', fontSize: 12 }}>
                        Verifier Type
                      </Typography>
                      <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#212b36' }}>
                        Bank/3rd Party
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <FaRegUser size={20} style={{ color: '#13519d' }} />
                    <Box>
                      <Typography variant="body2" sx={{ color: '#637381', fontSize: 12 }}>
                        Verified Location
                      </Typography>
                      <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#212b36' }}>
                        Jaipur
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Card>

            <Box textAlign="right" mb={3}>
              <Button
                variant="contained"
                onClick={(e) => setOpenComments(true)}
                sx={{
                  backgroundColor: '#13519d',
                  color: '#fff',
                  borderRadius: '8px',
                  fontWeight: 600,
                  textTransform: 'none',
                  px: 3,
                  boxShadow: 'none',
                  '&:hover': {
                    backgroundColor: '#0d3b75',
                    boxShadow: 'none'
                  }
                }}
              >
                Add Comments
              </Button>
            </Box>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4}>
                <Card
                  sx={{
                    borderRadius: '20px',
                    border: '1px solid #e2e8f0',
                    boxShadow: '0 4px 14px rgba(0,0,0,0.03)',
                    p: 2.5,
                    height: '52vh',
                    overflow: 'auto'
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{ fontSize: 15, fontWeight: 700, color: '#13519d', mb: 1.5 }}
                  >
                    Latest
                  </Typography>
                  <OppositeContentTimeline />
                </Card>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Card
                  sx={{
                    borderRadius: '20px',
                    border: '1px solid #e2e8f0',
                    boxShadow: '0 4px 14px rgba(0,0,0,0.03)',
                    p: 2.5,
                    height: '52vh',
                    overflow: 'auto'
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{ fontSize: 15, fontWeight: 700, color: '#13519d', mb: 1.5 }}
                  >
                    Last 12 Months
                  </Typography>
                  <OppositeContentTimeline />
                </Card>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Card
                  sx={{
                    borderRadius: '20px',
                    border: '1px solid #e2e8f0',
                    boxShadow: '0 4px 14px rgba(0,0,0,0.03)',
                    p: 2.5,
                    height: '52vh',
                    overflow: 'auto'
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{ fontSize: 15, fontWeight: 700, color: '#13519d', mb: 1.5 }}
                  >
                    Historical
                  </Typography>
                  <OppositeContentTimeline />
                </Card>
              </Grid>
            </Grid>

            {/* popup start */}
            <Dialog open={openComments} fullWidth PaperProps={{ sx: { borderRadius: '16px' } }}>
              <DialogTitle
                className="popupTitle"
                sx={{
                  p: 2.5,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: 600, color: '#212b36' }}>
                  Add New Comments
                </Typography>
                <IconButton
                  onClick={(e) => {
                    setOpenComments(false);
                    setSelectRequest(' ');
                    setAssignTo(' ');
                    setcomments('');
                  }}
                  size="small"
                  sx={{ color: '#637381' }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ p: 3 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12}>
                    <Typography
                      variant="h6"
                      className="formLabel"
                      sx={{ fontSize: 13, fontWeight: 600, color: '#637381', mb: 1 }}
                    >
                      Task
                    </Typography>
                    <Select
                      fullWidth
                      inputProps={{
                        className: `textInput customSelectBox dissabledMenu${selectRequest}`
                      }}
                      value={selectRequest}
                      onChange={(e) => setSelectRequest(e.target.value)}
                    >
                      <MenuItem value=" " disabled>
                        Task
                      </MenuItem>
                      {taskMenu.length > 0
                        ? taskMenu.map((item, index) => (
                            <MenuItem value={item.typeId} key={index}>
                              {item.typeName}
                            </MenuItem>
                          ))
                        : ''}
                    </Select>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Typography
                      variant="h6"
                      className="formLabel"
                      sx={{ fontSize: 13, fontWeight: 600, color: '#637381', mb: 1 }}
                    >
                      Assign to
                    </Typography>
                    <Select
                      fullWidth
                      inputProps={{
                        className: `textInput customSelectBox dissabledMenu${assignTo}`
                      }}
                      value={assignTo}
                      onChange={(e) => {
                        setAssignTo(e.target.value);
                      }}
                    >
                      <MenuItem value=" " disabled>
                        Select Assign To
                      </MenuItem>
                      {assignToList.length > 0
                        ? assignToList.map((item, index) => (
                            <MenuItem key={index} value={item.userId}>
                              {item.fullName}
                            </MenuItem>
                          ))
                        : ''}
                    </Select>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Typography
                      variant="h6"
                      className="formLabel"
                      sx={{ fontSize: 13, fontWeight: 600, color: '#637381', mb: 1 }}
                    >
                      Comments
                    </Typography>
                    <TextField
                      fullWidth
                      multiline
                      rows={3}
                      inputProps={{
                        className: 'textInput'
                      }}
                      placeholder="Comments"
                      value={comments}
                      onChange={(e) => setcomments(e.target.value)}
                    />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions sx={{ p: 2.5 }}>
                <Button
                  onClick={(e) => {
                    setOpenComments(false);
                    setSelectRequest(' ');
                    setAssignTo(' ');
                    setcomments('');
                  }}
                  variant="outlined"
                  sx={{
                    borderColor: '#e2e8f0',
                    color: '#637381',
                    borderRadius: '8px',
                    fontWeight: 600,
                    textTransform: 'none',
                    mr: 1,
                    '&:hover': { borderColor: '#cbd5e1', bgcolor: '#f8fafc' }
                  }}
                >
                  Close
                </Button>
                <Button
                  onClick={(e) => {
                    handleSubmitComments(e);
                  }}
                  variant="contained"
                  sx={{
                    backgroundColor: '#13519d',
                    color: '#fff',
                    borderRadius: '8px',
                    fontWeight: 600,
                    textTransform: 'none',
                    px: 3,
                    boxShadow: 'none',
                    '&:hover': {
                      backgroundColor: '#0d3b75',
                      boxShadow: 'none'
                    }
                  }}
                >
                  Submit
                </Button>
              </DialogActions>
            </Dialog>
            {/* Create list popup end */}
          </Box>
          <Dialog
            open={open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{ sx: { borderRadius: '16px' } }}
          >
            <DialogContent sx={{ p: 3 }}>
              <DialogContentText
                id="alert-dialog-description"
                sx={{ color: '#212b36', fontWeight: 500 }}
              >
                {validationMsg}
              </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
              <Button
                onClick={(e) => setOpen(false)}
                sx={{
                  backgroundColor: '#13519d',
                  color: '#fff',
                  borderRadius: '8px',
                  fontWeight: 600,
                  textTransform: 'none',
                  '&:hover': { backgroundColor: '#0d3b75' }
                }}
              >
                Retry
              </Button>
            </DialogActions>
          </Dialog>

          <ApiErrorMessage
            openApiError={openApiError}
            setOpenApiError={setOpenApiError}
            errorMessage={errorMessage}
          />
        </Container>
        <Footer />
      </Box>
    </Page>
  );
}
